const sanitizeHeaderString = (value) => {
  if (value == null) return null;
  const str = String(value).trim();
  return str ? str : null;
};

const shouldSanitizeMlsTransport = (endpoint, init = {}) => {
  if (typeof endpoint !== 'string') return false;
  const method = String(init?.method || 'GET').toUpperCase();
  if (method !== 'POST') return false;
  return /^\/api\/v1\/mls\/groups\/[^/]+\/messages(?:[/?].*)?$/.test(endpoint);
};

export const sanitizeMlsRequestInit = (endpoint, init = {}) => {
  if (!shouldSanitizeMlsTransport(endpoint, init)) {
    return init;
  }

  const sanitized = { ...init };
  const headers = { ...(init.headers || {}) };
  sanitized.headers = headers;

  const rawEpoch = sanitizeHeaderString(headers['X-MLS-Epoch']);
  if (rawEpoch == null) {
    delete headers['X-MLS-Epoch'];
  } else {
    const numericEpoch = Number(rawEpoch);
    if (!Number.isFinite(numericEpoch) || numericEpoch < 0) {
      delete headers['X-MLS-Epoch'];
    } else {
      headers['X-MLS-Epoch'] = rawEpoch;
    }
  }

  const hasEpochHeader = headers['X-MLS-Epoch'] != null;

  const rawSuite = sanitizeHeaderString(headers['X-MLS-Ciphersuite']);
  if (rawSuite == null) {
    delete headers['X-MLS-Ciphersuite'];
  } else {
    let numericSuite = Number(rawSuite);
    if (!Number.isFinite(numericSuite) && /^0x[0-9a-f]+$/i.test(rawSuite)) {
      numericSuite = Number.parseInt(rawSuite, 16);
    }
    const legacySuite = numericSuite === 0x004d || numericSuite === 77 || numericSuite === 0;
    if (!hasEpochHeader && legacySuite) {
      delete headers['X-MLS-Ciphersuite'];
    } else {
      headers['X-MLS-Ciphersuite'] = rawSuite;
    }
  }

  if (typeof sanitized.body === 'string') {
    try {
      let parsed = JSON.parse(sanitized.body);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        let mutated = false;

        if ('epoch' in parsed) {
          const normalizedEpoch = Number(parsed.epoch);
          if (!Number.isFinite(normalizedEpoch) || normalizedEpoch < 0) {
            delete parsed.epoch;
            mutated = true;
          } else if (parsed.epoch !== normalizedEpoch) {
            parsed.epoch = normalizedEpoch;
            mutated = true;
          }
        }

        const rawMsgType = parsed.msg_type ?? parsed.msgType;
        const normalizedMsgType =
          typeof rawMsgType === 'string' ? rawMsgType.trim().toLowerCase() : null;

        if (normalizedMsgType === 'public_message') {
          const sanitizedBody = {};
          const senderId =
            parsed.sender_client_id ?? parsed.senderClientId ?? undefined;
          if (senderId != null) {
            sanitizedBody.sender_client_id = senderId;
          }
          const clientMsgId =
            parsed.client_msg_id ?? parsed.clientMsgId ?? undefined;
          if (clientMsgId != null) {
            sanitizedBody.client_msg_id = clientMsgId;
          }
          const envelopeB64 =
            parsed.envelope_b64 ?? parsed.envelopeB64 ?? undefined;
          if (envelopeB64 != null) {
            sanitizedBody.envelope_b64 = envelopeB64;
          }
          if (Object.prototype.hasOwnProperty.call(parsed, 'epoch')) {
            const normalizedEpoch = Number(parsed.epoch);
            if (Number.isFinite(normalizedEpoch) && normalizedEpoch >= 0) {
              sanitizedBody.epoch = normalizedEpoch;
            }
          }
          sanitizedBody.msg_type = 'public_message';

          parsed = sanitizedBody;
          mutated = true;
        }

        if (mutated) {
          sanitized.body = JSON.stringify(parsed);
        }
      }
    } catch {}
  }

  return sanitized;
};

export default sanitizeMlsRequestInit;
